<template>
    <detail-form
        v-if="ibeaconMessageForm"
        v-model="ibeaconMessageForm">
        <template v-slot:content="{ form }">
            <detail-form-item
                disabled
                cols="6"
                type="text"
                v-model="form.id"
                :label="$t('ibeaconMessage.details.id')"/>

            <detail-form-item
                required
                cols="6"
                type="dateRange"
                height="32px"
                v-model="form.effectiveDates"
                :label="$t('ibeaconMessage.details.effectiveDates')"/>

            <v-col cols="12">
                <div class="subtitle-2 pb-2 font-weight-bold">
                    {{ $t('ibeaconMessage.details.messageDetails') }}
                </div>

                <v-tabs
                    grow
                    hide-slider
                    v-model="tab">
                    <v-tab
                        v-for="lang in langCodeList"
                        :key="lang.langCode">
                        {{ lang.text }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        v-for="lang in langCodeList"
                        :key="lang.langCode">
                        <detail-form-item
                            imageFile
                            v-model="getTabMessageByLangCode(lang.langCode).file"
                            cols="12"
                            type="file"
                            :label="$t('ibeaconMessage.details.image')"
                            :defaultFile.sync="getTabMessageByLangCode(lang.langCode).thumbnailUrl"
                            :preferedSize="[1200,800]"
                            @image-size-mismatch="onThumbnailSizeMismatch"/>
                        <detail-form-item
                            required
                            v-model="getTabMessageByLangCode(lang.langCode).title"
                            cols="12"
                            type="text"
                            :label="$t('ibeaconMessage.details.title')"/>
                        <detail-form-item
                            required
                            v-model="getTabMessageByLangCode(lang.langCode).subtitle"
                            cols="12"
                            type="textarea"
                            :label="$t('ibeaconMessage.details.subtitle')"/>
                        <detail-form-item
                            v-model="getTabMessageByLangCode(lang.langCode).condition"
                            cols="12"
                            type="textarea"
                            :label="$t('ibeaconMessage.details.condition')"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </template>
    </detail-form>
</template>

<script>
import DetailForm from '@/components/forms/DetailForm'
import DetailFormItem from '@/components/forms/DetailFormItem'

export default {
    name: 'IBeaconMessageDetailsView',

    model: {
        prop: 'ibeaconMessage'
    },

    components: {
        DetailForm,
        DetailFormItem
    },

    props: {
        ibeaconMessage: {
            type: Object,
            default: () => {}
        }
    },

    data () {
        return {
            tab: null,
            langCodeList: [
                {
                    langCode: 'en',
                    text: 'English'
                },
                {
                    langCode: 'th',
                    text: 'Thai'
                },
                {
                    langCode: 'zhHans',
                    text: 'Chinese'
                },
                {
                    langCode: 'ru',
                    text: 'Russian'
                }
            ]
        }
    },

    computed: {
        ibeaconMessageForm: {
            get () {
                if (!this.ibeaconMessage) {
                    return null
                }

                if (!this.ibeaconMessage.effectiveDates) {
                    const effectiveDates = []
                    if (this.ibeaconMessage.effectiveStartDate) {
                        effectiveDates.push(this.ibeaconMessage.effectiveStartDate)
                    }

                    if (this.ibeaconMessage.effectiveEndDate) {
                        effectiveDates.push(this.ibeaconMessage.effectiveEndDate)
                    }

                    this.$set(this.ibeaconMessage, 'effectiveDates', effectiveDates)
                }

                if (!this.ibeaconMessage.tabMessages) {
                    const messages = this.ibeaconMessage?.messages ?? []
                    this.langCodeList.forEach(lang => {
                        const isMatchLangCode = !!messages.find(message => message.langCode === lang.langCode)
                        if (!isMatchLangCode) {
                            messages.push({
                                langCode: lang.langCode
                            })
                        }
                    })
                    this.$set(this.ibeaconMessage, 'tabMessages', messages)
                }

                return this.ibeaconMessage
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    },

    methods: {
        getTabMessageByLangCode (langCode) {
            return this.ibeaconMessageForm?.tabMessages?.find(message => message.langCode === langCode) ?? {}
        },

        delete () {
            return this.$store.dispatch('ibeaconMessage/deleteIBeaconMessage', this.ibeaconMessageForm)
        },

        create () {
            return this.$store.dispatch('ibeaconMessage/createIBeaconMessage', this.ibeaconMessageForm)
        },

        update () {
            return this.$store.dispatch('ibeaconMessage/updateIBeaconMessage', this.ibeaconMessageForm)
        },

        onThumbnailSizeMismatch () {
            this.$app.alert(
                'File Size MisMatch',
                'Thumbnail size must be 1200x800px'
            )
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-tabs-items {
    border: 2px solid #00000024;
    border-top: 0px;
}

::v-deep .v-tab {
    background: #dededf;
}

::v-deep .v-tab--active {
    background: white;
    border: 2px solid #00000024;
    border-bottom: 0px;
}
</style>
